import React, { useCallback, useEffect, useMemo } from 'react';
import { Form, Modal, Select } from 'antd';

import { defaultFilterOptions } from 'components/common/utils';
import { classnames } from 'lib/classnames';
import useI18n from 'lib/hooks/useI18n';

import styles from './SettingTable.module.less';

const cx = classnames(styles);

type ValueProps = {
  permissions: string[];
};

interface ModalProps {
  initialValues?: ValueProps;
  list: Record<string, any>[];
  visible: boolean;
  loading: boolean;
  onSubmit: (values: ValueProps) => void;
  onCancel: () => void;
  width: number;
  title: string;
}

const PagePermissionModal: React.FC<ModalProps> = ({
  initialValues,
  list,
  visible,
  onSubmit,
  onCancel,
  loading,
  width,
  title,
}) => {
  const [form] = Form.useForm();
  const { t } = useI18n();

  useEffect(() => {
    // // 获取初始化数据
    form.setFieldsValue(initialValues);
  }, [form, initialValues]);

  const handleSubmit = useCallback(() => {
    const values = form.getFieldsValue();
    console.info('handleSubmit', values);
    onSubmit(values);
  }, [form, onSubmit]);

  const selectOptions = useMemo(() => {
    if (!list) return [];
    const groupList = list.filter(item => !item.parent && item.type === 'Group');
    const result = [];
    const fillResult = (data: Record<string, any>[], parentName?: string) => {
      data.forEach(item => {
        const children = list.filter(child => child.parent === item.objectId && child.type === 'Page');
        if (children.length) {
          result.push({
            label: <span>{parentName ? `${parentName}-${item.name}` : item.name}</span>,
            title: parentName ? `${parentName}-${item.name}` : item.name,
            key: item.key,
            options: children.map(child => ({
              label: <span>{child.name}</span>,
              value: child.objectId,
            })),
          });
        }
        const groupChildren = list.filter(child => child.parent === item.objectId && child.type === 'Group');
        if (groupChildren.length) {
          fillResult(groupChildren, item.name);
        }
      });
    };

    fillResult(groupList);
    return result;
  }, [list]);

  return (
    <Modal
      maskClosable={false}
      confirmLoading={loading}
      width={width}
      title={title}
      open={visible}
      onOk={() => handleSubmit()}
      onCancel={onCancel}
    >
      <Form colon={false} autoComplete="off" className={cx('page-permission-form-wrapper')} form={form}>
        <Form.Item
          className={cx('select-item')}
          name="permissions"
          label={t('pages.permission.roles.PagePermissionModal.menu')}
        >
          <Select
            loading={loading}
            filterOption={defaultFilterOptions}
            mode="multiple"
            placeholder={t('pages.permission.roles.PagePermissionModal.select')}
            options={selectOptions}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PagePermissionModal;
